export default "__VITE_ASSET__BJX6pyeK__"